import React, {Component} from 'react';
import propTypes from 'prop-types';
import Moment from "moment/moment"
import {Badge} from "reactstrap"
import {Link} from "react-router-dom"


class ItemWithdrawal extends Component {
    render() {
        const {withdrawal} = this.props;
        const now = Moment();
        const createdTime = Moment(withdrawal.created);
        const backwardTime = Moment.duration(createdTime.diff(now));
        const badgeColorMap = {
            completed: 'success',
            rejected: 'danger',
            pending: 'warning',
            nothing: 'light'
        }

        return (
            <tr className="ItemWithdrawal">
                <td><Link to={'/a/users/'.concat(withdrawal.receiver._id)}> {withdrawal.receiver.name}</Link></td>
                <td>{withdrawal.method}</td>
                <td>{withdrawal.meta.paypal}</td>

                <td>
                    <div className='tooltip-container'>{backwardTime.humanize(true)}
                        <span
                            className="tooltip-text">{createdTime.format('DD-MM-YYYY')}</span>
                    </div>
                </td>
                <td><Badge color={badgeColorMap[withdrawal.status]}>{withdrawal.status}</Badge></td>
                <td>{'$' + withdrawal.total}</td>
            </tr>
        );
    }
}

ItemWithdrawal.propTypes = {
    withdrawal: propTypes.object.isRequired,

}

export default ItemWithdrawal;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/affiliate/withdrawal/ItemWithdrawal.js